import React, { useEffect, useState, memo } from "react";
import packageJson from "../../package.json";
import { Col, Row } from "react-bootstrap";
import {
  Viewer,
  Worker,
  RotateDirection,
  SpecialZoomLevel,
  ScrollMode,
  PrimaryButton,
} from "@react-pdf-viewer/core";
import { SelectionMode } from "@react-pdf-viewer/selection-mode";
import { rotatePlugin } from "@react-pdf-viewer/rotate";
import { zoomPlugin } from "@react-pdf-viewer/zoom";
import { selectionModePlugin } from "@react-pdf-viewer/selection-mode";
import { thumbnailPlugin } from "@react-pdf-viewer/thumbnail";
import { GrRotateRight } from "react-icons/gr";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/thumbnail/lib/styles/index.css";
import "@react-pdf-viewer/zoom/lib/styles/index.css";
import "@react-pdf-viewer/selection-mode/lib/styles/index.css";
import { Stack } from "@mui/material";

const PdfThumbnailView = memo(
  ({ pdf, pagesArray = [], pageOriginalNum = [] }) => {
    const [pdfFile, setPdfFile] = useState(null);
    const [activePage, setActivePage] = useState(0);

    // Initialize plugins
    const thumbnailPluginInstance = thumbnailPlugin({ thumbnailWidth: 150 });
    const rotatePluginInstance = rotatePlugin();
    const zoomPluginInstance = zoomPlugin();
    const selectionModePluginInstance = selectionModePlugin();

    const { Thumbnails } = thumbnailPluginInstance;
    const { RotatePage } = rotatePluginInstance;
    const { ZoomInButton, ZoomOutButton, ZoomPopover } = zoomPluginInstance;
    const [selcttionMode, setSelectionMode] = useState("Text");

    const { SwitchSelectionModeButton } = selectionModePluginInstance;
    const defaultLayoutPluginInstance = {
      fullScreenPlugin: {
        onEnterFullScreen: (zoom) => {
          zoom(SpecialZoomLevel.PageFit);
          defaultLayoutPluginInstance.toolbarPluginInstance.scrollModePluginInstance.switchScrollMode(
            ScrollMode.Wrapped,
          );
        },
        onExitFullScreen: (zoom) => {
          zoom(SpecialZoomLevel.PageWidth);
          defaultLayoutPluginInstance.toolbarPluginInstance.scrollModePluginInstance.switchScrollMode(
            ScrollMode.Vertical,
          );
        },
      },
    };

    useEffect(() => {
      if (pdf) {
        const url = URL.createObjectURL(pdf);
        setPdfFile(url);
        return () => URL.revokeObjectURL(url);
      }
    }, [pdf]);

    const loadpage = (selectedMode) => {
      setSelectionMode(selectedMode);
    };

    const renderThumbnailItem = (thumbnailProps) => {
      if (!thumbnailProps) return null;

      setActivePage(thumbnailProps.currentPage);

      return (
        <div
          key={thumbnailProps.key}
          className={
            pagesArray?.indexOf(thumbnailProps.pageIndex + 1) !== -1
              ? "disable-pdf-thumbnail"
              : ""
          }
          style={{
            position: "relative",
            marginBottom: "10px",
            display: "block",
          }}
        >
          <div
            onClick={thumbnailProps.onJumpToPage}
            className={
              thumbnailProps.pageIndex === thumbnailProps.currentPage
                ? "abc"
                : ""
            }
          >
            {thumbnailProps.renderPageThumbnail}
          </div>
          <div
            className={
              thumbnailProps.pageIndex === thumbnailProps.currentPage
                ? "pdf-pagenum-active"
                : "pdf-pagenum-inactive"
            }
          >
            {thumbnailProps.renderPageLabel}
          </div>
          {pageOriginalNum?.length > 0 && (
            <div>
              <p>Splitted Page-{pageOriginalNum[thumbnailProps.pageIndex]}</p>
            </div>
          )}
        </div>
      );
    };

    if (!pdfFile) return null;

    return (
      <Worker
        workerUrl={`https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${packageJson.dependencies["pdfjs-dist"]}/pdf.worker.min.js`}
      >
        <div className="rpv-core__viewer" style={{ height: "80vh" }}>
          <Stack
            sx={{
              paddingBottom: "0rem",
              borderBottom: "1px solid #d6d5d5",
            }}
          >
            <div
              style={{
                alignItems: "center",
                backgroundColor: "white",
                display: "flex",
                justifyContent: "center",
                padding: "8px",
                color: "#9499A1",
                borderRadius: "10px",
              }}
            >
              <ZoomInButton
                style={{
                  color: "#9499A1 !important",
                }}
              ></ZoomInButton>
              <ZoomPopover
                style={{
                  color: "#9499A1 !important",
                  border: "1px solid #DEE2E6",
                  borderRadius: "7px",
                }}
              />
              <ZoomOutButton />
              <RotatePage>
                {(rotateProps) => (
                  <div
                    onClick={() => {
                      rotateProps.onRotatePage(
                        activePage,
                        RotateDirection.Forward,
                      );
                    }}
                    style={{
                      width: "32px",
                      height: "32px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                      borderTopLeftRadius: "4px",
                      borderTopRightRadius: "4px",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.backgroundColor = "#e5e5e5")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.backgroundColor = "transparent")
                    }
                  >
                    <GrRotateRight />
                  </div>
                )}
              </RotatePage>
              {
                <span onClick={() => loadpage("Text")}>
                  <SwitchSelectionModeButton
                    mode={SelectionMode.Text}
                  ></SwitchSelectionModeButton>
                </span>
              }
              {
                <span onClick={() => loadpage("Hand")}>
                  <SwitchSelectionModeButton
                    mode={SelectionMode.Hand}
                  ></SwitchSelectionModeButton>
                </span>
              }
            </div>
          </Stack>
          <Row
            style={{
              height: "100vh",
              marginLeft: "0rem",
              backgroundColor: "white",
              marginRight: "0rem",
              borderRadius: "10px",
              paddingTop: "1.5rem",
            }}
          >
            <Col
              sm={3}
              style={{
                height: "105%",
                padding: "0px !important",
                backgroundColor: "white",
              }}
            >
              <Thumbnails renderThumbnailItem={renderThumbnailItem} />
            </Col>
            <Col sm={9}>
              <div style={{ width: "100%", height: "100%" }}>
                <Viewer
                  fileUrl={pdfFile}
                  plugins={[
                    thumbnailPluginInstance,
                    rotatePluginInstance,
                    zoomPluginInstance,
                    selectionModePluginInstance,
                  ]}
                  defaultScale={SpecialZoomLevel.PageWidth}
                />
              </div>
            </Col>
          </Row>
        </div>
      </Worker>
    );
  },
);

PdfThumbnailView.displayName = "PdfThumbnailView";

export default PdfThumbnailView;
